import script from "./SingleDevice.vue?vue&type=script&setup=true&lang=js"
export * from "./SingleDevice.vue?vue&type=script&setup=true&lang=js"

import "./SingleDevice.vue?vue&type=style&index=0&id=4b173dfc&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b173dfc"]])

export default __exports__